import React from 'react';
import { useTranslation } from 'next-i18next';
import { userContext } from '@components/auth/auth.context';

interface LoginBoxProps {
	title: string;
	cta: string;
	classes: string;
}

export const LoginBoxComponent = ({ title, cta, classes }: LoginBoxProps) => {
	const { t } = useTranslation();
	const auth = React.useContext(userContext);

	return (
		<div
			id="login-wrapper-id"
			className="flexbox colls default-vertical-spacing"
		>
			<button
				type="button"
				id="login-cta"
				className={`default-btn md-size flexbox centered ${classes}`}
				style={{ color: 'white', marginTop: '2em' }}
				onClick={() => {
					auth.openLoginModal();
				}}
			>{t(cta)}
			</button>
			<div
				id="login-title"
				className="main-whitebox-err"
			>{t(title)}
			</div>
		</div>
	);
};

export default LoginBoxComponent;
